import detectTabbing from './lib/detect-tabbing'
detectTabbing()

import externalLinks from './lib/external-links'
externalLinks()

import subLinks from './lib/sub-links'
subLinks()

import smoothAnchors from './lib/smooth-anchors'
smoothAnchors()

import vhCheck from 'vh-check'
vhCheck()

import ElementQueries from 'css-element-queries/src/ElementQueries'
ElementQueries.listen()

import './components/Ultralazy.js'
import './components/Navigation.js'
import './components/FitText.js'
import './components/Subnav.js'
import './components/ContactForm.js'
import './components/AutoTextarea.js'
import './components/Gallery.js'
import './components/Monogrid.js'
import './components/PlottedMap.js'